import { all, call, put, takeLatest } from 'redux-saga/effects';
import queryApi from '../../utils/fetchApi';
import Urler from '../../utils/serviceUrl';
import { fetchUserCoinsStart } from '../user/user.actions';
import { createWithdrawalFailure, createWithdrawalSuccess, fetchWithdrawalsFailure, fetchWithdrawalsSuccess } from './withdrawals.actions';
import withdrawalActionTypes from './withdrawals.types';

export function* fetchWithdrawals({ payload: token }) {
    try {
        let res = yield queryApi({ method: 'GET', url: yield Urler('/withdrawals/me'), bearer: token });
        if (res.status === 'success') {
            yield put(fetchWithdrawalsSuccess(res.data.withdrawals));
        } else {
            yield put(fetchWithdrawalsFailure(res.message));
        }
    } catch (e) {
        yield put(fetchWithdrawalsFailure(e.message));
    }
}

export function* createWithdrawal({ payload: { token, amount, bankName, accountNumber, accountName } }) {
    try {
        let res = yield queryApi({
            method: 'POST',
            url: yield Urler('/withdrawals/request'),
            bearer: token,
            data: { amount, bankName, accountNumber, accountName }
        });
        if (res.status === 'success') {
            yield put(createWithdrawalSuccess(res.data.withdrawal));
            yield put(fetchUserCoinsStart(token)); // Update coins balance after withdrawal
        } else {
            yield put(createWithdrawalFailure(res.message));
        }
    } catch (e) {
        yield put(createWithdrawalFailure(e.message));
    }
}

export function* onFetchWithdrawalsStart() {
    yield takeLatest(withdrawalActionTypes.FETCH_WITHDRAWALS_START, fetchWithdrawals);
}

export function* onCreateWithdrawalStart() {
    yield takeLatest(withdrawalActionTypes.CREATE_WITHDRAWAL_START, createWithdrawal);
}

export function* withdrawalsSagas() {
    yield all([
        call(onFetchWithdrawalsStart),
        call(onCreateWithdrawalStart)
    ]);
}
